import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const partnershipFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'nameLike',
    label: '제휴사 명',
    placeholder: '제휴사 명을 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'isUsing',
    label: '사용 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.activated, value: 'true' },
      { label: OPTIONS_CONST.notActivated, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
